import { render, staticRenderFns } from "./addAdministrator.vue?vue&type=template&id=e5fe1aca&scoped=true&"
import script from "./addAdministrator.vue?vue&type=script&lang=js&"
export * from "./addAdministrator.vue?vue&type=script&lang=js&"
import style0 from "./addAdministrator.vue?vue&type=style&index=0&id=e5fe1aca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fe1aca",
  null
  
)

export default component.exports